import { render, staticRenderFns } from "./labelPrint.vue?vue&type=template&id=1bf5a474&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./labelPrint.vue?vue&type=script&lang=js&"
export * from "./labelPrint.vue?vue&type=script&lang=js&"
import style0 from "./labelPrint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports